module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cn-only",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_c('span', {
    staticClass: "epub-scb"
  }, [_vm._v("“THE FIRST THING")]), _vm._v(" you do is stop calling me Mister. Since we share your most occult secret we can shed formality.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She drew in a deep breath, held it before exhaling. “Steve?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That’s it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Then please call me Alison.” She managed a weak smile. “Ali among my family.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Alison,” I repeated. “Ali. I like both. Okay, I’m sure you could pull together fifty thousand dollars.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Easily.” Her nose wrinkled. “You think I should pay?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Not exactly. I think you should appear to be willing to pay. Look, you’re a highly intelligent woman—surely you know that a blackmailer’s first bite isn’t his last. Right now your Tommy is testing you. Your response will tell him how far he can go.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Alison nodded slowly. “I understand—but, please, he’s not ‘my Tommy.’ I guess he’s any woman’s Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Any woman who seems vulnerable to his practiced eye.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You’re suggesting he’s done this before?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I shrugged. “Seems like he ran a pretty smooth operation. Seduction, lights, camera, the demand note—nothing on impulse. Question is, was he an independent operator, or was he hired to compromise you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Hired? By whom?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You said you have political enemies, people in both parties who covet your Senate seat. Four years ago you won by how much?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Fifty-four percent.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Low enough to suggest that personal scandal could eliminate you next time, or even force you to resign and vacate your seat.” I paused. “Get along with your governor?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Of necessity.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And if you resigned he could appoint a crony to your seat, even appoint himself.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She nodded. “That’s true. Oh, Steve, thank God I came to you. Since Tommy’s call—ugh, I loathe the name—I’ve barely been able to sleep, hardly think, but you’re putting the situation in perspective, organizing my thinking.” She sighed relievedly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You have more organizing to do,” I told her. “Are you good at lists?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Helpless without them.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Good. I want a list of all your staff employees and relevant bio information—married, divorced, drunks, dopeheads, gamblers, womanizers. Gather the information quietly, by which I mean don’t start asking questions. Pull everything together—you can get salary figures from the Senate payroll office—and note how long you’ve known each employee and the length of his or her employment with you. The sooner I have the information, the better.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll work in my office tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, don’t work there, assemble the raw information and put it together in your apartment.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She sat back and gazed at me. “You think this was an inside job?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You were set up by someone who knew about your holiday cruise. Who made travel arrangements?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“The Senate travel office.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Who on your staff actually dealt with the travel office?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Let’s see—I asked my secretary but my media specialist said it would be his pleasure to handle things.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“His name?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Arnold Munger. But my plans were known by the entire staff. I gave them a pre-Christmas party, and they gave me an office sendoff the day before I left.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("I wrote down the name Munger. “Very likely you have a complete list of passengers from the cruise?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, I kept it as a souvenir. You’ll want that, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes. Checkmark any names Tommy socialized with. Ah, do you happen to have Tommy’s business card?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“That suggests he’s not who he told you he is. Brokers usually scatter business cards like confetti.” I paused to focus my mind. “Any chance you have a photo of Tommy? Say, from the shipboard photographer?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How about the videotape? Is he recognizable enough to pull a still picture?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She blushed. “The tape shows only his back—his naked back—but "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("my")]), _vm._v(" face is there and very recognizable.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“So he positioned the video camera to show an unidentifiable white male covering you, while you looked at the camera.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Oh God.” Her hands tightened into balls with white knuckles. “I’m so ashamed. You can’t possibly understand how ashamed I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Look, Ali,” I said sharply, “you weren’t ashamed before you saw the tape, you shouldn’t be now. Don’t drown in self-pity, it’ll paralyze you and I have much for you to do. Now, where is the tape?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“In—in my apartment.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Tomorrow morning when banks open put it in your safe deposit box. Your husband doesn’t have a key?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Or power of attorney?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She shook her head.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Good. By the way, where was Harlan while you were cruising the Caribbean?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Before I left he told me he planned on Christmas with his parents in Omaha. The rest of the time I suppose he was in Philadelphia—doubtless with his lady love.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll want to know about her—name, address of the love nest, anything you learned.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“All right, but I know very little. Steve, you think Harlan might have—?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It’s not unknown for husbands to compromise wives for various reasons, including financial gain. But that may well have nothing to do with your problem. Still, you might consider his possible motive.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Do you have a tape recorder in your apartment?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“One I use to dictate staff memos and speeches.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Phone mike? Little black suction cup?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I—let me see—I think one came with the recorder, but I’ve never used it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I’ll get one tomorrow, just in case. Now—and this is important—don’t answer your apartment telephone until you can record incoming calls. Let your answering machine earn its keep. Tommy won’t speak to a machine. He won’t want a record of his voice, and more significantly he’ll want to talk to you, his victim, determine how intimidated and ready to surrender you are.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“An hour ago I was almost ready to give in. Now, with all you’ve said in my mind, I know I won’t have to.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Good, that’s a long way toward winning. Now, the most secure place to give me the material you’ll be working on tonight is at your apartment.” I gave her one of my cards and added my home telephone. “Call me tomorrow when everything’s ready and I’ll come by.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("She smiled wanly. “Looks like a late-nighter for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“In a worthy cause.” I left my desk and went to the corner cellarette. From it I took two small snifters and added Hine cognac to each. Alison took one and our glasses touched. Before sipping, she said, “I think a toast is in order, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Definitely. Look, Ali, cancel your guilt trip, let me handle the grief.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Willingly.” She raised her glass and murmured, “Death to my enemies.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Death to your enemies,” I echoed, and drank deeply.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Having no idea how prophetic our toast would be.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf59e72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 72
// module chunks = 0